module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar ind-4",
    class: _vm.navActive,
    on: {
      "mouseenter": _vm.setNavActive,
      "mouseleave": _vm.removeNavActive
    }
  }, [_c('div', {
    staticClass: "navbar-inner"
  }, [_c('nav-button', {
    attrs: {
      "type": "back",
      "clickevent": _vm.back_click,
      "customclass": [_vm.back.custom, _vm.navActive]
    }
  }, [_vm._v(_vm._s(_vm.back.text))]), _vm._v(" "), _c('a', {
    staticClass: "content-translate pdf-link",
    class: [_vm.hasPDF, _vm.navActive],
    attrs: {
      "href": _vm.pdf,
      "target": "blank"
    }
  }, [_c('download-svg'), _vm._v(" "), _c('span', {
    staticClass: "hide-sm"
  }, [_vm._v("Download")]), _vm._v(" PDF\n    ")], 1), _vm._v(" "), _c('nav-button', {
    attrs: {
      "type": "next",
      "clickevent": _vm.next_click,
      "customclass": [_vm.next.custom, _vm.navActive]
    }
  }, [_vm._v(_vm._s(_vm.next.text))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07f95614"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/navbar.vue
// module id = 591
// module chunks = 1